import React, { useState } from "react";
import { Header, Segment, Image, Accordion } from "semantic-ui-react";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = (index) => {
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const faqItems = [
    {
      question: "1. What is Innferre?",
      answer: "Innferre is a SaaS application designed to enhance enterprise data management and retrieval using Generative Artificial Intelligence (GenAI). It allows users to upload, organize, and extract insights from their data using advanced machine learning and natural language processing."
    },
    {
      question: "2. Who can use Innferre?",
      answer: "Innferre is intended for two types of users: Admins and regular Users. Admins have full access to all features, while Users have access to specific functionalities based on their assigned roles."
    },
    {
      question: "3. What is a dataset in Innferre?",
      answer: "A dataset is a collection of related documents grouped for a specific purpose or project. It facilitates interactions with Generative AI to extract more insights from the documents."
    },
    {
      question: "4. How do I add a new dataset?",
      answer: "Only Admins can add new datasets. Admins can navigate to the Data Console, click the 'Add Dataset' button, and enter the required information to create a new dataset."
    },
    {
      question: "5. How do I upload documents to a dataset?",
      answer: "Admins can upload documents to a dataset by selecting the dataset in the Data Console and clicking the 'Add Documents' button. The documents must be in PDF format."
    },
    {
      question: "6. Can I preview a document before downloading it?",
      answer: "Yes, Admins can preview documents directly in the Innferre App without downloading them."
    },
    {
      question: "7. How do I manage users?",
      answer: "Admins can manage users by navigating to the Admin Console, where they can add, edit, or delete users, as well as assign datasets to users."
    },
    {
      question: "8. How can I request access to a dataset?",
      answer: "Users can request access to a dataset by navigating to the Dataset Access module and selecting the dataset they need access to. They can then submit a request, which will be reviewed by an Admin."
    },
    {
      question: "9. How do Admins give access to a dataset?",
      answer: "Admins can approve or deny dataset access requests by navigating to the Requests section in the Admin Console. They can view pending requests and grant or deny access accordingly."
    },
    {
      question: "10. How do I start a chat with the AI Assistant?",
      answer: "Both Admins and Users can start a chat by selecting the AI Assistant from the menu, choosing a dataset, and typing a question. The AI will provide responses based on the documents in the selected dataset."
    },
    {
      question: "11. How do I view chat history?",
      answer: "Chat history can be viewed by navigating to the Chat History section in the AI Assistant. Users can see all their previous conversations and review the questions and answers."
    },
    {
      question: "12. How do I filter chat history?",
      answer: "Users can filter chat history by date range, dataset, or other criteria using the filter options available in the Chat History section."
    },
    {
      question: "13. What is summarization and how do I use it?",
      answer: "Summarization is a feature that provides summaries of the documents within a dataset. Users can click the Summarization button in the AI Assistant to view document summaries."
    },
    {
      question: "14. How do I ask questions and get answers from the bot?",
      answer: "Users can initiate a conversation with the AI Assistant by selecting a dataset and typing their questions. The bot will provide answers based on the documents in the dataset."
    },
    {
      question: "15. How do I view sources for the bot's responses?",
      answer: "Users can view the sources for the bot's responses by looking at the citation provided with each response. This includes the source PDF document and page numbers."
    },
    {
      question: "16. How do I give feedback for the bot's response?",
      answer: "Users can give feedback by using the thumbs up or thumbs down feature next to each response. Additional comments can be added with the thumbs down option."
    },
    {
      question: "17. How do I request new features?",
      answer: "Users can request new features by contacting the support team through the provided support channels in the application."
    },
    {
      question: "18. How do I access the Innferre App?",
      answer: "You can access the Innferre App via a web browser (IE/Chrome) on a desktop or mobile device using the URL provided by the admin. Enter your credentials to log in."
    },
    {
      question: "19. What should I do if I encounter issues with the app?",
      answer: "For troubleshooting and support, you can contact the IT support team via the contact information provided in the user manual."
    },
    {
      question: "20. How do I log out of the Innferre App?",
      answer: "Click on the profile icon at the bottom corner of the application and select 'Logout' to exit the system."
    }
  ];

  return (
    <Segment className="faq-segment">
      <div className="banner-container">
        <Image src="/images/Banners.png" alt="FAQ Banner" className="privacy-policy-banner" />
        <div className="banner-text">
          <Header as="h1" className="Bannertext">FAQs</Header>
          <p className="Bannercontent" id="Bannercontentfaq">
            Find answers to the most common questions about Innferre. Learn how our AI platform works, how we protect your data, and more.
          </p>
        </div>
      </div>
      <div className="content-container">
        <Accordion styled fluid>
          {faqItems.map((item, index) => (
            <React.Fragment key={index}>
              <Accordion.Title active={activeIndex === index} index={index} onClick={() => handleClick(index)}>
                <div className="accordion-title">
                <span className="Questions">{item.question}</span>
                  <Image src={activeIndex === index ? "/images/Arrow.svg" : "/images/Arrowdown.svg"} alt="toggle" className="accordion-icon" />
                </div>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === index}>
                <p className="Answers">{item.answer}</p>
              </Accordion.Content>
            </React.Fragment>
          ))}
        </Accordion>
      </div>
    </Segment>
  );
};

export default Faq;
